import type { PropertyAuditEntry } from "../types/propertyAudit";

const PROPERTY_AUDIT_FIELD_LABELS: Record<string, string> = {
  rent_value: "Valor do aluguel",
  tenant_id: "Inquilino",
  is_rented: "Status de locação",
};

function humanizeFieldName(field: string): string {
  return field
    .replace(/_id$/, "")
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function displayPropertyAuditValue(
  value: string | null | undefined
): string {
  if (value == null || value.trim() === "") return "—";
  return value;
}

export function getPropertyAuditFieldLabel(entry: Pick<PropertyAuditEntry, "field" | "field_label">): string {
  const label = entry.field_label?.trim();
  if (label) return label;
  return PROPERTY_AUDIT_FIELD_LABELS[entry.field] ?? humanizeFieldName(entry.field);
}

export function getPropertyAuditSourceLabel(
  entry: Pick<PropertyAuditEntry, "source" | "source_label">
): string {
  const label = entry.source_label?.trim();
  if (label) return label;
  if (entry.source === "property_history") return "Ciclo de locação";
  if (entry.source === "property_audit") return "Alteração de cadastro";
  return "Alteração";
}

export function getPropertyAuditAuthorName(
  author?: Pick<PropertyAuditAuthorShape, "first_name" | "last_name"> | null
): string {
  if (!author) return "Automático";

  const firstName = author.first_name?.trim() ?? "";
  if (firstName) return firstName;

  const lastName = author.last_name?.trim() ?? "";
  return lastName || "Usuário desconhecido";
}

type PropertyAuditAuthorShape = {
  first_name?: string | null;
  last_name?: string | null;
};

export function isRentalCycleAudit(
  entry: Pick<PropertyAuditEntry, "source" | "source_label" | "event">
): boolean {
  if (entry.event && Object.values(entry.event).some(Boolean)) return true;

  const sourceLabel = entry.source_label?.toLowerCase() ?? "";
  if (sourceLabel.includes("ciclo de locação")) return true;

  return entry.source === "property_history";
}
